<template>
  <div>
    <v-card dark>
      <v-card-title class="d-flex justify-space-between">
        <div>
          <span class="text-h6">Filtros {{ tableActive }}</span>
        </div>
        <div>
          <v-icon>mdi-filter</v-icon>
        </div>
      </v-card-title>
      <!-- Filtros para Produtos -->
      <div v-if="tableActive.toLowerCase() == 'produtos'">
        <v-card-text>
          <v-row dense>
            <v-col cols="4">
              <c-input
                label="Produto"
                placeholder="Digite um produto"
                v-model="filters.product.description"
                :maxLength="50"
              />
            </v-col>
            <v-col cols="4">
              <c-input
                label="Categoria"
                placeholder="Digite uma categoria"
                v-model="filters.product.category"
                :maxLength="50"
              />
            </v-col>
            <v-col cols="4">
              <c-input
                label="Fabricante"
                placeholder="Digite um fabricante"
                v-model="filters.product.manufacturer"
                :maxLength="12"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                dark
                dense
                outlined
                class="text-caption"
                label="Estoque"
                type="number"
                placeholder="Quantidade"
                v-model="filters.product.quantity"
                :append-icon="operatorQuantity"
                @click:append="operatorChange('operatorQuantityIndex')"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                dark
                dense
                outlined
                class="text-caption"
                label="Peso"
                type="number"
                placeholder="Quantidade"
                v-model="filters.product.weight"
                :append-icon="operatorWeight"
                @click:append="operatorChange('operatorWeightIndex')"
              />
            </v-col>
            <v-col justify-center>
              <div class="d-flex">
                <v-switch
                  class="customClass mr-3"
                  dark
                  dense
                  outlined
                  color="success"
                  label="Somente Produtos Ativos"
                  v-model="filters.product.vendaInternet"
                />
                <v-switch
                  class="customClass"
                  dark
                  dense
                  outlined
                  color="success"
                  label="Somente Produtos Integrados"
                  v-model="filters.product.integrados"
                />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" @click="searchProducts">
            <span>Buscar</span>
          </v-btn>
        </v-card-actions>
      </div>
      <div v-if="tableActive.toLowerCase() == 'pedidos'">
        <v-card-text>
          <v-row dense>
            <v-col md="3" xs="12" sm="3" class="d-sm-inline-block">
              <c-input-date
                :label="'Início'"
                :type="'date'"
                max="getDate"
                v-model.trim="filters.order.dataini"
              />
            </v-col>
            <v-col md="3" xs="12" sm="3" class="d-sm-inline-block">
              <c-input-date
                :label="'Fim'"
                :type="'date'"
                max="getDate"
                v-model.trim="filters.order.datafim"
              />
            </v-col>
            <v-col md="3" xs="12" sm="3" class="d-sm-inline-block">
              <v-text-field
                dark
                dense
                outlined
                class="text-caption"
                label="Numero"
                type="number"
                placeholder="Número"
                v-model="filters.order.numero"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" @click="searchOrders">
            <span>Buscar</span>
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    cInput: () => import('@/components/shared/base-input/BaseInput'),
    cInputDate: () => import('@/components/shared/base-input/BaseInputDate'),
  },
  data: () => {
    return {
      operatorQuantityIndex: 0,
      operatorWeightIndex: 0,
      operatorIconOptions: [
        'mdi-equal',
        'mdi-less-than-or-equal',
        'mdi-less-than',
        'mdi-greater-than-or-equal',
        'mdi-greater-than',
      ],
    }
  },
  props: {
    tableActive: {
      type: String,
      default: '',
      required: true,
    },

    filters: {
      type: Object,
      default: () => {
        return {
          product: {
            description: null,
            category: null,
            manufacturer: null,
            quantity: null,
            operatorQuantityIndex: null,
            operatorWeight: null,
            integrados: null,
            vendaInternet: false,
          },
          order: {
            dataini: null,
            datafim: null,
            numero: null,
          },
        }
      },
    },
  },
  computed: {
    operatorQuantity() {
      return this.operatorIconOptions[this.operatorQuantityIndex]
    },
    operatorWeight() {
      return this.operatorIconOptions[this.operatorWeightIndex]
    },
  },
  methods: {
    operatorChange(type) {
      this[type]++
      if (this[type] > this.operatorIconOptions.length - 1) this[type] = 0
    },
    searchProducts() {
      let filterData = {
        action: { value: 'produtos.lista' },
        filters: { ...this.filters },
      }
      // if (this.filters.product.description != '')
      //   filterData.filters.description = this.filters.product.description
      // if (this.filters.product.category != '')
      //   filterData.filters.categoryName = this.filters.product.category
      // if (this.filters.product.manufacturer != '')
      //   filterData.filters.manufacturerName = this.filters.product.manufacturer
      // if (this.filters.product.quantity != '') {
      //   filterData.filters.quantity = this.filters.product.quantity
      //   filterData.filters.operatorQuantity = this.operatorQuantityIndex
      // }
      // if (this.filters.product.weight != '') {
      //   filterData.filters.weight = this.filters.product.weight
      //   filterData.filters.operatorWeight = this.operatorWeightIndex
      // }

      // // traz tudo se não estiver ativo
      // if (this.filters.product.vendaInternet)
      //   filterData.filters.vendaInternet = this.filters.product.vendaInternet
      // if (this.filters.product.integrados)
      //   filterData.filters.integrados = this.filters.product.integrados

      this.$emit('filter', filterData)
    },

    searchOrders() {
      let filterData = {
        action: { value: 'pedidos.lista' },
        filters: {},
      }
      Object.keys(this.filters.order).forEach((e) => {
        if (this.filters.order[e] && this.filters.order[e] != '')
          filterData.filters[e] = this.filters.order[e]
      })

      this.$emit('filter', filterData)
    },
    getDate(type = 'I') {
      const date1 = new Date().setDate(
        new Date().getDate() - (type == 'I' ? 30 : 0)
      )
      const date = new Date(date1)
      let day = this.f(date.getDate())
      let month = this.f(date.getMonth() + 1)
      let year = date.getFullYear()
      const fullDate = year + '-' + month + '-' + day

      return fullDate
    },
    f(n) {
      return n > 9 ? n : '0' + n
    },
  },
  mounted() {
    this.filters.order.dataini = this.getDate('I')
    this.filters.order.datafim = this.getDate('F')
  },
}
</script>
<style lang="css" scoped>
.customClass >>> label {
  font-size: 0.8em;
}
</style>
